export const BACKGROUND_COLOR = '#005252'
export const DESCRIPTION_COLOR = '#f9f9f9ed'
export const CIRCLE_BACKGROUND_COLOR = '#14222d'

export const PRIMARY_BUTTON_COLOR = '#0ea06c'
export const PRIMARY_BUTTON_COLOR_ACTIVE = '#5e3fff'

export const PLACEHOLDER_COLOR = '#757575'
